import { TranslationKey } from './en';

export const nl: Record<TranslationKey, string> = {
  'common.cancel': 'Annuleren',
  'common.close': 'Sluiten',
  'common.copy': 'Kopieer',
  'common.copied': 'Gekopieerd!',
  'common.logout': 'Uitloggen',
  'common.logoutTooltip': 'Uitloggen',
  'common.refreshTooltip': 'Vernieuwen',
  'common.backToOverview': 'Terug naar overzicht',
  'common.noDescription': 'Geen beschrijving',
  'common.retry': 'Opnieuw proberen',
  'common.yes': 'Ja',
  'common.no': 'Nee',
  'common.saveButton': 'Opslaan',
  'common.savingButton': 'Opslaan...',
  'common.total': 'Totaal',
  'common.col.date': 'Datum',
  'common.col.status': 'Status',

  'errors.genericError': 'Er ging iets mis.',
  'errors.defaultError': 'Er is een fout opgetreden',
  'errors.tryAgain': 'Er is iets misgegaan. Probeer het opnieuw.',
  'errors.signupFailed': 'Je organisatie kon niet worden aangemaakt. Log opnieuw in en probeer het nogmaals; neem contact op met support als dit blijft gebeuren.',
  'errors.joinFailed': 'Je aanvraag kon niet worden ingediend. Log opnieuw in en probeer het nogmaals.',
  'errors.requestFailed': 'Er ging iets mis bij het aanvragen.',
  'errors.api.badRequest': 'Ongeldige aanvraag. Controleer de ingevoerde gegevens.',
  'errors.api.unauthorized': 'Je sessie is verlopen. Log opnieuw in.',
  'errors.api.forbidden': 'Je hebt geen toegang tot deze functie.',
  'errors.api.notFound': 'Het gevraagde item is niet gevonden.',
  'errors.api.conflict': 'Deze actie kan niet worden uitgevoerd vanwege een conflict.',
  'errors.api.tooMany': 'Te veel aanvragen. Probeer het later opnieuw.',
  'errors.api.serverError': 'Er is een serverfout opgetreden. Probeer het later opnieuw.',
  'errors.api.seatLimitReached': 'Seat limiet bereikt voor het huidige plan.',
  'errors.api.onlyPendingCancel': 'Alleen aanvragen in behandeling kunnen worden geannuleerd.',
  'errors.api.timeout': 'De aanvraag duurde te lang. Controleer je internetverbinding en probeer het opnieuw.',

  'nav.servers': 'Servers',
  'nav.workflows': 'Workflows',
  'nav.myRequests': 'Mijn aanvragen',
  'nav.users': 'Gebruikers',
  'nav.usage': 'Verbruik',
  'nav.help': 'Help',

  'help.page.title': 'Aan de slag met Chat & MCP',
  'help.page.subtitle': 'Leer hoe je AI chat gebruikt en MCP servers koppelt.',
  'help.whatIsChat.title': 'Wat is Chat?',
  'help.whatIsChat.body':
    'Chat is een zelf-gehoste AI assistent op basis van open modellen. Je data blijft binnen het platform — niets wordt gedeeld met externe partijen. Alle gesprekken zijn privé en alleen zichtbaar voor jou.',
  'help.startChat.title': 'Hoe open ik de chat?',
  'help.startChat.body':
    'Klik op de "Chat" knop bovenaan de Servers pagina. Je wordt automatisch ingelogd met hetzelfde account als het portaal.',
  'help.addMcpPortal.title': 'Stap 1: Installeer een MCP in chat',
  'help.addMcpPortal.body':
    'Ga naar de detailpagina van de MCP die je wilt gebruiken (klik op de MCP kaart). Klik op de "Installeer in chat" knop naast de status chip. De knop verandert naar "Geïnstalleerd" als het klaar is. Hiermee wordt de MCP als tool server geregistreerd in je chat omgeving.',
  'help.connectMcp.title': 'Stap 2: Koppel de MCP in chat',
  'help.connectMcp.body':
    'Open Chat en klik op je profielfoto (linksonder). Ga naar Instellingen > Integrations. Klik onder "Manage Tool Servers" op de + knop. Stel het type in op "MCP Streamable HTTP". Kopieer de MCP URL van het Connect tabblad op de server detail pagina. Laat Auth op "None" staan en klik op Save. De MCP tools zijn nu beschikbaar in je chats.',
  'help.functionCalling.title': 'Stap 3: Schakel Function Calling in',
  'help.functionCalling.body':
    'Start een nieuw gesprek. Klik op "Controls" (rechtsboven, schuifregelaar-icoon). Verander onder "Advanced Params" de instelling "Function Calling" van "Default" naar "Native". Dit zorgt ervoor dat de AI de tools daadwerkelijk gebruikt.',
  'help.testMcp.title': 'Stap 4: Test de MCP',
  'help.testMcp.body':
    'Klik in de berichtenbalk op het connector-icoon (vier-blokjes icoon) en zet je MCP tools aan. Typ daarna een bericht zoals "Zoek contacten met de naam Jan". De AI roept de MCP tool aan en toont echte resultaten uit je systeem. Gebruik een model dat tool calling ondersteunt (bijv. Claude Sonnet).',
  'help.createProject.title': 'Project instructies gebruiken',
  'help.createProject.body':
    'Sommige MCP servers hebben project instructies (CLAUDE.md / GEMINI.md). Kopieer deze naar je AI project configuratie zodat de AI context heeft over hoe de tools effectief te gebruiken.',

  'login.title': 'Slimme extensies',
  'login.defaultSubtitle': 'Handige tools voor je favoriete AI-chatclient.',
  'login.loginButton': 'Inloggen',
  'login.email': 'E-mail adres',
  'login.emailPlaceholder': 'mail@domein.nl',
  'login.continue': 'Verder',
  'login.selectOrganization': 'Kies je organisatie',
  'login.noOrganization': 'Geen organisatie gevonden voor dit e-maildomein.',
  'login.back': 'Terug',
  'login.loading': 'Organisaties opzoeken...',
  'login.sessionExpired': 'Je sessie is verlopen. Log opnieuw in.',
  'login.signInTitle': 'Inloggen',
  'login.signInSubtitle': 'Je wordt doorgestuurd naar het inlogscherm van jouw organisatie.',
  'login.signIn': 'Doorgaan naar inloggen',
  'signupProgress.title.creating': '{org} wordt aangemaakt',
  'signupProgress.title.signingIn': 'Je wordt ingelogd',
  'signupProgress.subtitle': 'We richten je workspace in en verversen je sessie. Dit duurt maar even.',
  'signupProgress.orgFallback': 'je workspace',
  'signupProgress.step.accountConnected': 'Account verbonden',
  'signupProgress.step.creatingOrg': 'Organisatie aanmaken',
  'signupProgress.step.signingIn': 'Je wordt ingelogd',
  'signupProgress.footer': 'Sluit dit tabblad niet — we sturen je automatisch door.',
  'login.joinTitle': 'Toegang aanvragen tot {org}',
  'login.joinSubtitle': 'Er bestaat al een organisatie voor dit e-maildomein. Log in met je werkaccount om toegang aan te vragen — een beheerder keurt het goed.',
  'login.joinWithGoogle': 'Toegang aanvragen met Google',
  'login.joinWithMicrosoft': 'Toegang aanvragen met Microsoft',
  'memberPending.title.pending': 'Wachten op goedkeuring',
  'memberPending.body.pending': 'Je verzoek om lid te worden van {org} wacht op goedkeuring door een beheerder. Zodra het is goedgekeurd krijg je toegang.',
  'memberPending.title.rejected': 'Verzoek afgewezen',
  'memberPending.body.rejected': 'Je verzoek om lid te worden van {org} is afgewezen. Neem contact op met de beheerder als je denkt dat dit onterecht is.',
  'memberPending.logout': 'Uitloggen',
  'pendingMembers.section.title': 'Openstaande aanvragen',
  'pendingMembers.section.empty': 'Geen openstaande aanvragen.',
  'pendingMembers.approve': 'Goedkeuren',
  'pendingMembers.reject': 'Afwijzen',
  'pendingMembers.source.kcAuto': 'Automatisch via SSO',
  'login.notValid': 'Het e-mailadres is niet geldig',
  'login.registerTitle': 'Registreer je organisatie',
  'login.registerSubtitle': 'Er bestaat nog geen organisatie voor dit e-mailadres. Geef je organisatie een naam en ga verder met je werkaccount.',
  'login.organizationName': 'Naam van de organisatie',
  'login.organizationNamePlaceholder': 'bijv. Acme B.V.',
  'login.continueWith': 'Ga verder met',
  'login.or': 'of',
  'login.signInGoogle': 'Inloggen met Google',
  'login.signInMicrosoft': 'Inloggen met Microsoft',
  'login.signUpGoogle': 'Registreren met Google',
  'login.signUpMicrosoft': 'Registreren met Microsoft',
  'login.signUpEmail': 'Registreren met email',
  'login.registering': 'Je organisatie wordt aangemaakt…',
  'login.registeredMessage': 'Je organisatie is aangemaakt. Log opnieuw in om je beheerdersrol te activeren.',
  'login.signInAgain': 'Opnieuw inloggen',
  'login.signupFailed': 'Registratie mislukt. Probeer het opnieuw.',
  'login.idpUnavailable': 'De identity provider is tijdelijk niet bereikbaar. Probeer het opnieuw.',
  'login.serverUnreachable': 'Kan de server niet bereiken. Controleer je verbinding en probeer het opnieuw.',

  'servers.page.title': 'MCP Servers',
  'servers.page.subtitle': 'Ontdek beschikbare MCP servers en vraag toegang aan.',
  'servers.chat.button': 'Chat',
  'servers.chat.notConfiguredTooltip': 'Chat is niet geconfigureerd.',
  'servers.empty.adminTitle': 'Geen MCP servers gevonden',
  'servers.empty.userTitle': 'Geen toegang tot MCPs',
  'servers.empty.adminSubtitle': 'Er zijn momenteel geen MCP servers beschikbaar voor jouw organisatie.',
  'servers.empty.userSubtitle': 'Je hebt nog geen toegang tot MCPs. Vraag je beheerder om je toegang te geven.',

  'servers.sort.activated': 'Geactiveerd eerst',
  'servers.sort.nameAsc': 'Naam A–Z',
  'servers.sort.nameDesc': 'Naam Z–A',
  'servers.sort.newest': 'Nieuwste eerst',
  'servers.sort.oldest': 'Oudste eerst',
  'servers.filter.allApps': 'Alle applicaties',
  'servers.filter.selected': 'geselecteerd',

  'serverCard.activateButton': 'MCP activeren',
  'serverCard.instantAddButton': 'Direct toevoegen',
  'serverCard.slotLimitTooltip': 'Plan limiet bereikt (upgrade je plan)',

  'serverDetail.backButton': 'Alle servers',
  'serverDetail.notFound.title': 'MCP server niet gevonden',
  'serverDetail.tools.defaultTag': 'Overig',
  'serverDetail.header.activateMcp': 'MCP activeren',
  'serverDetail.header.requestAccess': 'Toegang aanvragen',
  'serverDetail.blocked': 'Deze MCP is tijdelijk uitgeschakeld tot {until}.',
  'serverDetail.tabs.about': 'Over',
  'serverDetail.tabs.connect': 'Verbinden',
  'serverDetail.tabs.tools': 'Tools ({count})',
  'serverDetail.tabs.skills': 'Skills ({count})',
  'serverDetail.tabs.users': 'Gebruikers',
  'serverDetail.tabs.logs': 'Logs',
  'serverDetail.about.empty': 'Geen uitgebreide beschrijving beschikbaar.',
  'serverDetail.skills.empty': 'Geen skills beschikbaar.',
  'serverDetail.copySkill': 'Kopieer skill',
  'serverDetail.connect.noAccess.title': 'Geen toegang',
  'serverDetail.connect.noAccess.body': 'Vraag eerst toegang aan om connectie-instructies te bekijken.',
  'serverDetail.connect.inactiveAlert': 'Authenticatie werkt pas als deze MCP is geactiveerd voor je organisatie.',
  'serverDetail.connect.step.addServer': 'MCP Server toevoegen',
  'serverDetail.connect.step.authenticate': 'Authenticeren',
  'serverDetail.connect.step.createProject': 'Project aanmaken',
  'serverDetail.connect.step.addCustomInstructions': 'Custom instructions toevoegen',
  'serverDetail.connect.step.runCommand': 'Voer het volgende commando uit in je terminal:',
  'serverDetail.connect.step.addSkills': 'Skills toevoegen',
  'serverDetail.connect.claude.desktop.step1.hint': 'Open Claude Desktop of claude.ai en ga naar Settings \u2192 Connectors \u2192 Add custom connector. Voer de onderstaande URL in en klik op Add.',
  'serverDetail.connect.claude.desktop.step2.hint': 'Na het toevoegen verschijnt de MCP server in je connectorlijst. Klik erop om te authenticeren met je inloggegevens.',
  'serverDetail.connect.claude.desktop.step3.hint': 'Maak een nieuw Project aan via het menu links in Claude en voeg de MCP server toe als connector in de projectinstellingen.',
  'serverDetail.connect.claude.desktop.step4.hint': 'Voeg onderstaande instructies toe aan het Project instructions veld van je project voor de beste resultaten.',
  'serverDetail.connect.claude.code.step1.altHint': 'Of voeg toe aan',
  'serverDetail.connect.claude.code.step2.hint': 'Bij het eerste gebruik opent Claude Code automatisch een browservenster om in te loggen. Na authenticatie is de MCP server klaar voor gebruik.',
  'serverDetail.connect.claude.code.step3.title': 'Project instructies (CLAUDE.md)',
  'serverDetail.connect.claude.code.step3.hint': 'Maak een CLAUDE.md bestand aan in je project root met onderstaande content.',
  'serverDetail.connect.claude.code.step4.hint': 'Kopieer onderstaande skills naar de .claude/skills/ directory in je project.',
  'serverDetail.connect.copilot.app.step1.hint': 'Open Microsoft 365 Copilot Studio en navigeer naar je agent. Ga naar Actions \u2192 Add action \u2192 MCP Server. Voer de onderstaande URL in.',
  'serverDetail.connect.copilot.app.step2.hint': 'Na het toevoegen van de MCP server vraagt Copilot je om in te loggen. Log in met je inloggegevens om toegang te autoriseren.',
  'serverDetail.connect.copilot.app.step3.hint': 'Voeg onderstaande inhoud toe als instructies aan je Copilot agent om het gebruik van deze MCP server te sturen.',
  'serverDetail.connect.copilot.app.step4.hint': 'Voeg de volgende instructies toe aan je Copilot agent voor de beste resultaten.',
  'serverDetail.connect.copilot.vscode.step1.hint': 'Open VS Code en ga naar Settings (Ctrl+,) \u2192 zoek "mcp". Klik op "Edit in settings.json" en voeg de onderstaande configuratie toe onder "github.copilot.chat.mcp.servers":',
  'serverDetail.connect.copilot.vscode.step2.hint': 'Bij het eerste gebruik opent Copilot automatisch een browservenster om in te loggen. Log in met je inloggegevens.',
  'serverDetail.connect.copilot.vscode.step3.hint': 'Maak een .github/copilot-instructions.md bestand aan in je project root met onderstaande inhoud.',
  'serverDetail.connect.copilot.vscode.step4.hint': 'Voeg de volgende instructies toe aan je .github/copilot-instructions.md bestand voor de beste resultaten.',
  'serverDetail.connect.chatgpt.step1.hint': 'Open ChatGPT en ga naar Settings \u2192 Connectors \u2192 Advanced. Voer de onderstaande URL in en klik op Save.',
  'serverDetail.connect.chatgpt.step2.hint': 'Na het aanmaken word je automatisch doorgestuurd om te authenticeren. Log in met je inloggegevens.',
  'serverDetail.connect.chatgpt.step3.hint': 'Maak een nieuw Project aan in de ChatGPT sidebar en voeg de MCP server toe als connector.',
  'serverDetail.connect.chatgpt.step4.hint': 'Voeg onderstaande instructies toe aan je Project instructions voor de beste resultaten.',
  'serverDetail.connect.gemini.app.step1.title': 'Gem aanmaken',
  'serverDetail.connect.gemini.app.step1.hint': 'Open Gemini en ga naar Gem manager \u2192 New Gem. Geef het een naam en beschrijving.',
  'serverDetail.connect.gemini.app.step2.title': 'Gem instructies',
  'serverDetail.connect.gemini.app.step2.hint': 'Plak onderstaande instructies in het Instructions veld van je Gem.',
  'serverDetail.connect.gemini.app.step3.hint': 'Voeg onderstaande instructies toe aan het Instructions veld van je Gem.',
  'serverDetail.connect.gemini.cli.step1.altHint': 'Of voeg toe aan .gemini/settings.json:',
  'serverDetail.connect.gemini.cli.step2.hint': 'Bij het eerste gebruik opent Gemini CLI automatisch een browservenster om in te loggen. Na authenticatie is de MCP server klaar voor gebruik.',
  'serverDetail.connect.gemini.cli.step3.title': 'Project instructies (GEMINI.md)',
  'serverDetail.connect.gemini.cli.step3.hint': 'Maak een GEMINI.md bestand aan in je project root met onderstaande content.',
  'serverDetail.connect.gemini.cli.step4.hint': 'Kopieer onderstaande skills naar de .gemini/skills/ directory in je project.',
  'serverDetail.environment': 'Omgeving',
  'serverDetail.environments': 'Omgevingen',
  'serverDetail.selectEnvironment': 'Selecteer omgeving',

  'serverDetail.connected': 'Verbonden',

  'serverDetail.remove': 'Verwijder MCP',
  'serverDetail.removing': 'Verwijderen...',
  'serverDetail.removeConfirm':
    'Weet je zeker dat je deze MCP wilt verwijderen? Alle gebruikerstoegang en chatinstallaties worden verwijderd.',

  'myRequests.page.title': 'Mijn aanvragen',
  'myRequests.page.subtitle': 'Overzicht van je aanvragen.',
  'myRequests.empty.title': 'Geen aanvragen',
  'myRequests.empty.subtitle': 'Je hebt nog geen aanvragen ingediend.',
  'myRequests.platformRequests.sectionTitle': 'Platform aanvragen',
  'myRequests.accessRequests.sectionTitle': 'Toegangsaanvragen',
  'myRequests.platformRequests.col.tier': 'Tier',
  'myRequests.col.status': 'Status',
  'myRequests.col.date': 'Datum',
  'myRequests.col.note': 'Opmerking',
  'myRequests.col.actions': '',
  'myRequests.cancel': 'Annuleren',
  'myRequests.cancelConfirm': 'Weet je zeker dat je deze aanvraag wilt annuleren?',
  'myRequests.accessRequests.col.server': 'MCP Server',
  'myRequests.accessRequests.col.type': 'Type',
  'myRequests.requestType.organization': 'Organisatie',
  'myRequests.requestType.user': 'Gebruiker',

  'seats.page.title': 'Gebruikers beheer',
  'seats.page.subtitle': 'seats in gebruik',
  'seats.addButton': 'Seat toewijzen',
  'seats.col.email': 'E-mail',
  'seats.col.assignedBy': 'Toegewezen door',
  'seats.col.chat': 'Chat',
  'seats.chat.disable': 'Chat uitschakelen',
  'seats.chat.enable': 'Chat inschakelen',
  'seats.deleteTooltip': 'Seat verwijderen',
  'seats.deleteConfirm': 'Weet je zeker dat je deze seat wilt verwijderen?',
  'seats.table.empty': 'Nog geen seats toegewezen.',
  'seats.accessDenied.title': 'Geen toegang',
  'seats.accessDenied.body': 'Gebruikers beheer is alleen beschikbaar voor beheerders.',
  'seats.assignDialog.title': 'Seat toewijzen',
  'seats.assignDialog.searchLabel': 'Zoek gebruiker',
  'seats.assignDialog.searchPlaceholder': 'Naam of e-mailadres',
  'seats.assignDialog.searchMinChars': 'Typ minimaal 2 tekens om te zoeken',
  'seats.assignDialog.noUsers': 'Geen gebruikers gevonden',
  'seats.assignDialog.assignButton': 'Toewijzen',
  'seats.assignDialog.assigningButton': 'Toewijzen...',

  'usage.page.title': 'Verbruik',
  'usage.page.subtitle': 'Huidige maand \u2014 kosten en verbruik voor je organisatie.',
  'usage.page.periodBanner': 'Deze maand tot nu toe \u00b7 {period}',
  'usage.historyButton': 'Voorgaande maanden',
  'usage.limitsButton': 'Limieten',
  'usage.dailyTable.title': 'Dagelijks overzicht',
  'usage.col.mcp': 'MCP',
  'usage.col.workflow': 'Workflows',
  'usage.col.chat': 'Chat',
  'usage.col.total': 'Totaal',
  'usage.dailyTable.empty': 'Geen data deze maand.',
  'usage.costSummary.title': 'Maandelijkse kosten',
  'usage.costSummary.subtitle': 'Wat deze maand wordt afgerekend',
  'usage.costSummary.fixedCosts': 'Vaste kosten',
  'usage.costSummary.platformCosts': 'MCP-gebruik',
  'usage.costSummary.workflowCosts': 'Workflow-uitvoeringen',
  'usage.costSummary.executionsSuffix': '{n} executies',
  'usage.costSummary.chatCosts': 'AI-chatgebruik',
  'usage.fixedCosts.title': 'Maandelijkse vaste kosten',
  'usage.fixedCosts.seats': 'Seats: {count} \u00d7 {price}',
  'usage.fixedCosts.mcps': 'MCPs: {count} \u00d7 {price}',
  'usage.fixedCosts.workflows': 'Workflows: {count} \u00d7 {price}',
  'usage.fixedCosts.subtotal': 'Subtotaal',
  'usage.percentOfLimit': '{pct}% van limiet ({budget})',
  'usage.breakdown.title': 'Kosten per bron',
  'usage.breakdown.mcpTitle': 'MCP-servers',
  'usage.breakdown.workflowTitle': 'Workflows',
  'usage.breakdown.showMore': 'Toon {count} meer',
  'usage.breakdown.showLess': 'Toon minder',
  'usage.breakdown.empty': 'Geen kosten',
  'usage.empty': 'Nog geen verbruiksgegevens. Gebruik MCP servers, workflows of chat om verbruik te genereren.',
  'usage.accessDenied.title': 'Geen toegang',
  'usage.accessDenied.body': 'Verbruik is alleen beschikbaar voor beheerders.',
  'usage.budgetDialog.title': 'Kostenlimieten instellen',
  'usage.budgetDialog.platformLimit': 'MCP-limiet (EUR/maand)',
  'usage.budgetDialog.workflowLimit': 'Workflow-limiet (EUR/maand)',
  'usage.budgetDialog.aiHourlyLimit': 'AI-uurlimiet voor workflows (EUR/uur)',
  'usage.budgetDialog.aiHourlyLimitHint':
    'Harde stop op automatische AI-aanroepen in workflows. Bij overschrijding stopt de workflow.',
  'usage.budgetDialog.aiHourlyLimitCeilingHint':
    'Platform-plafond: {ceiling}/uur. Neem contact op met de platform-admin om dit te verhogen.',
  'usage.budgetDialog.noLimit': 'Geen limiet',
  'usage.budgetDialog.hint': 'Stel 0 in of laat leeg om geen limiet te hanteren.',
  'usage.historyDialog.title': 'Voorgaande maanden',
  'usage.historyDialog.empty': 'Geen historische data beschikbaar.',
  'usage.historyDialog.col.month': 'Maand',
  'usage.historyDialog.col.seats': 'Seats',
  'usage.historyDialog.col.mcps': 'MCPs',
  'usage.historyDialog.col.fixedCosts': 'Vaste kosten',
  'usage.historyDialog.col.platform': 'MCP',
  'usage.historyDialog.col.workflows': 'Workflows',
  'usage.historyDialog.col.chat': 'Chat',
  'usage.historyDialog.col.total': 'Totaal',

  // AI quota widget
  'usage.aiQuota.title': 'AI-uurlimiet voor workflows',
  'usage.aiQuota.subtitle': 'Harde stop op automatische AI-aanroepen in workflows',
  'usage.aiQuota.spent': 'Dit uur verbruikt',
  'usage.aiQuota.quota': 'Limiet per uur',
  'usage.aiQuota.unmetered': 'Ongelimiteerd — geen uurlijkse limiet actief voor deze organisatie.',
  'usage.aiQuota.unavailable': 'Live AI-budget is tijdelijk niet beschikbaar.',
  'usage.aiQuota.helper': 'Loopt geleidelijk terug zodra oudere calls buiten het 1-uur venster vallen.',
  'usage.aiQuota.percentOfQuota': '{pct}% van uurlimiet',
  'usage.breakdown.workflowLabelPrefix': 'Workflow:',
  'usage.breakdown.subtitle': 'Variabele kosten per bron',

  'requestAccess.title': 'MCP activeren voor mijn organisatie',
  'requestAccess.success': 'Je aanvraag voor {serverName} is verzonden. Een beheerder zal deze beoordelen.',
  'requestAccess.description': 'Deze MCP is nog niet geactiveerd voor je organisatie. Geef aan voor welke omgeving je de MCP wilt activeren.',
  'requestAccess.envUrlLabel': 'Omgeving URL',
  'requestAccess.envUrlPlaceholder': 'https://api.mijnomgeving.nl',
  'requestAccess.envUrlHelper': 'De API URL van de omgeving waarvoor je toegang wilt',
  'requestAccess.messageLabel': 'Bericht (optioneel)',
  'requestAccess.messagePlaceholder': 'Waarom heb je toegang nodig?',
  'requestAccess.urlError': 'Voer een geldige HTTPS URL in (bijv. https://api.example.nl)',
  'requestAccess.environmentLabel': 'Omgeving',
  'requestAccess.submitButton': 'Aanvraag verzenden',
  'requestAccess.submittingButton': 'Verzenden...',

  'toolsTable.col.name': 'Naam',
  'toolsTable.col.type': 'Type',
  'toolsTable.col.required': 'Verplicht',
  'toolsTable.col.description': 'Beschrijving',
  'toolsTable.empty': 'Geen tools beschikbaar.',

  'logsTab.title': 'Recente logs',
  'logsTab.empty': 'Geen logs beschikbaar voor deze server.',
  'logsTab.col.tool': 'Tool',
  'logsTab.col.user': 'Gebruiker',
  'logsTab.col.responseTime': 'Response tijd',
  'logsTab.status.success': 'Success',
  'logsTab.status.error': 'Error',

  'usersTab.title': 'Gebruikersbeheer',
  'usersTab.empty': "Voeg een gebruiker toe in 'Gebruikers' om een gebruiker toegang te geven tot deze MCP.",
  'usersTab.col.user': 'Gebruiker',
  'usersTab.col.access': 'Toegang',
  'usersTab.revokeButton': 'Intrekken',
  'usersTab.activateButton': 'Activeren',

  'upgradeBanner.text': 'Upgrade naar team om met meer seats en hogere limieten te werken of naar productie voor onbeperkte seats, geen limieten en onze eigen EU hosted modellen.',
  'upgradeBanner.textTeam': 'Meer seats of MCPs nodig? Upgrade naar productie voor onbeperkte toegang, EU hosted chat modellen en alles wat {title} te bieden heeft.',
  'upgradeBanner.pending': 'Aanvraag is in behandeling',
  'upgradeBanner.upgradeTeamButton': 'Upgrade naar team',
  'upgradeBanner.upgradeEnterpriseButton': 'Activeer productie',

  'pricing.page.title': 'Kies een plan',
  'pricing.page.subtitle': 'Activeer het juiste plan voor je organisatie om te starten met MCP Hub.',
  'pricing.adminOnly': 'Alleen beheerders kunnen een plan aanvragen.',
  'pricing.pendingRequest': 'Er is al een aanvraag in behandeling. Je ontvangt bericht zodra deze is verwerkt.',
  'pricing.currentPlan.chip': 'Huidig plan',
  'pricing.button.current': 'Huidig plan',
  'pricing.button.requesting': 'Aanvragen...',
  'pricing.button.request': 'Aanvragen',
  'pricing.snackbar.submitted': 'Aanvraag ingediend \u2014 je ontvangt bericht zodra deze is verwerkt.',
  'pricing.tier.free.label': 'Free',
  'pricing.tier.free.tagline': 'Maak kennis met het MCP Platform',
  'pricing.tier.free.feature.mcps': '1 MCP activeren',
  'pricing.tier.free.feature.seats': '1 seat (alleen jezelf)',
  'pricing.tier.free.feature.calls': 'Max 100 calls per dag',
  'pricing.tier.team.label': 'Team',
  'pricing.tier.team.tagline': 'Voor gemeentelijke teams',
  'pricing.tier.team.feature.mcps': '3 MCPs activeren',
  'pricing.tier.team.feature.seats': '6 seats',
  'pricing.tier.team.feature.calls': 'Max 1.000 calls per dag',
  'pricing.tier.enterprise.label': 'Enterprise',
  'pricing.tier.enterprise.tagline': 'Maximale flexibiliteit voor grote organisaties',
  'pricing.tier.enterprise.feature.mcps': 'Onbeperkte MCPs',
  'pricing.tier.enterprise.feature.seats': 'Onbeperkte seats',
  'pricing.tier.enterprise.feature.calls': 'Onbeperkte calls',
  'pricing.tier.enterprise.feature.chat': 'European hosted modellen',
  'pricing.tier.enterprise.feature.governance': 'Guardrails & AI Governance',

  'pending.title': 'Aanvraag in behandeling',
  'pending.body': 'Je aanvraag is ontvangen. We nemen zo snel mogelijk contact op om je toegang te activeren.',

  'registration.welcome': 'Welkom bij {title}',
  'registration.heading': 'Hoe wil je {title} inzetten?',
  'registration.subheading': 'Kies de optie die het beste past bij jouw situatie. Je kunt later altijd upgraden.',
  'registration.tier.free.tagline': 'Verken de mogelijkheden',
  'registration.tier.team.tagline': 'Implementeer met een team',
  'registration.tier.enterprise.tagline': 'Volledig operationeel',
  'registration.messagePlaceholder': 'Optioneel: Vertel iets over je gebruik en verwachtingen...',
  'registration.submitButton': 'Aanvraag indienen',
  'registration.submitButtonFree': 'Direct testen',

  'authGuard.accessDenied.title': 'Geen toegang',
  'authGuard.accessDenied.body': 'Je hebt geen toegang tot de MCP Hub. Neem contact op met je beheerder om een seat te krijgen.',
  'authGuard.tryAgain': 'Opnieuw proberen',
  'authGuard.joinPrompt.title': 'Word lid van {org}',
  'authGuard.joinPrompt.body': 'Er bestaat al een organisatie voor jouw e-maildomein. Vraag toegang aan; een beheerder beoordeelt je aanvraag.',
  'authGuard.joinPrompt.requestAccess': 'Toegang aanvragen',
  'authGuard.joinPrompt.cancel': 'Nu niet',
  'authGuard.orgSignupPrompt.title': 'Stel je organisatie in',
  'authGuard.orgSignupPrompt.body': 'Er bestaat nog geen organisatie voor jouw account. Geef je organisatie een naam om je workspace af te ronden.',
  'authGuard.orgSignupPrompt.submit': 'Organisatie aanmaken',
  'authGuard.orgSignupPrompt.cancel': 'Uitloggen',

  'errorBoundary.title': 'Er is iets misgegaan',
  'errorBoundary.body': 'Probeer de pagina te vernieuwen. Als het probleem aanhoudt, neem contact op met support.',
  'errorBoundary.reloadButton': 'Pagina vernieuwen',

  'accessStatus.full_access': 'Verbonden',
  'accessStatus.org_linked_no_user': 'Geen toegang',
  'accessStatus.not_linked': 'Niet geactiveerd',
  'accessStatus.request_pending': 'Aanvraag verzonden',
  'accessStatus.instant_available': 'Direct beschikbaar',
  'accessStatus.active': 'Actief',

  'requestStatus.pending': 'In behandeling',
  'requestStatus.approved': 'Goedgekeurd',
  'requestStatus.denied': 'Afgewezen',
  'requestStatus.cancelled': 'Geannuleerd',

  'tierLabel.free': 'Free',
  'tierLabel.team': 'Team',
  'tierLabel.enterprise': 'Productie',

  'plan.page.title': 'Mijn plan',
  'plan.page.subtitle': 'Overzicht van het huidige plan en gebruik.',
  'plan.accessDenied.title': 'Geen toegang',
  'plan.accessDenied.body': 'Plan beheer is alleen beschikbaar voor beheerders.',
  'plan.activateCta.title': 'Activeer nu een plan',
  'plan.activateCta.body': 'Je hebt nog geen platform actief. Activeer een plan om MCPs te kunnen gebruiken.',
  'plan.activateCta.button': 'Plan activeren',
  'plan.organization': 'Organisatie',
  'plan.stat.mcps': 'MCPs actief',
  'plan.stat.seats': 'Seats in gebruik',
  'plan.changePlanButton': 'Plan wijzigen',
  'plan.tier.none': 'Geen plan',
  'plan.tier.free': 'Free',
  'plan.tier.team': 'Team',
  'plan.tier.enterprise': 'Enterprise',

  // Tier features (constants)
  'tier.free.label': 'Inrichting testen',
  'tier.free.feature.seats': '1 seat',
  'tier.free.feature.mcps': '1 MCP actief',
  'tier.free.feature.requests': 'Beperkte dagelijkse requests',
  'tier.team.label': 'Pilot implementatie',
  'tier.team.feature.seats': '6 seats',
  'tier.team.feature.mcps': '3 MCPs actief',
  'tier.team.feature.requests': 'Meer requests per dag',
  'tier.enterprise.label': 'Productie',
  'tier.enterprise.feature.seats': 'Onbeperkte seats',
  'tier.enterprise.feature.mcps': 'Alle MCPs',
  'tier.enterprise.feature.chat': 'Chat inbegrepen',

  'workflow.title': 'Workflows',
  'workflow.subtitle': 'Geautomatiseerde MCP tool chains voor jouw organisatie',
  'workflow.configure': 'Configureren',
  'workflow.instantAdd': 'Direct toevoegen',
  'workflow.requestAccess': 'Toegang aanvragen',
  'workflow.awaitingApproval': 'Wacht op goedkeuring',
  'workflow.empty': 'Nog geen workflows beschikbaar',
  'workflow.upgradeRequired': 'Upgrade je plan om workflows te gebruiken',
  'workflow.filter.allTriggers': 'Alle triggers',
  'workflow.trigger.manual': 'Handmatig',
  'workflow.trigger.cron': 'Ingepland',
  'workflow.trigger.mcp': 'MCP',
  'workflow.requestDialog.description': 'Geef per MCP server de gewenste omgevingsconfiguratie op.',
  'workflow.requestDialog.mcpConfig': 'MCP Server Configuratie',
  'workflow.requestDialog.variables': 'Variabelen',
  'workflow.requestDialog.variablesHelper': 'Waarden die je organisatie meegeeft voor de variabelen die deze workflow gebruikt. Laat leeg om later in te vullen via de koppeling-configuratie.',
  'workflow.requestDialog.seat': 'Gebruiker',
  'workflow.requestDialog.environment': 'Omgeving',
  'workflow.requestDialog.selectEnvironment': 'Selecteer een omgeving',
  'workflow.requestDialog.baseUrl': 'Doel URL',
  'workflow.requestDialog.message': 'Bericht (optioneel)',
  'workflow.requestDialog.messagePlaceholder': 'Extra context voor de beheerder...',
  'workflow.requestDialog.cancel': 'Annuleren',
  'workflow.requestDialog.submit': 'Aanvraag versturen',
  'workflow.requestDialog.attachmentLabel': 'Bijlage',
  'workflow.requestDialog.attachmentChoose': 'Bestand kiezen',
  'workflow.requestDialog.attachmentNone': 'Geen bestand gekozen',
  'workflow.requestDialog.attachmentRequired': 'Deze workflow vereist een bijlage.',
  'workflow.requestDialog.attachmentHelp': 'Dit bestand is de databron voor de workflow. Max 10 MB.',
  'workflow.tabs.flow': 'Flow',
  'workflow.tabs.connect': 'Verbinden',
  'workflow.connect.urlLabel': 'MCP server URL',
  'workflow.connect.urlHelp': 'Voeg deze URL toe als MCP server in Claude Desktop. Authenticatie verloopt via de SecureAccess login.',
  'workflow.connect.heroEyebrow': 'Verbinden via MCP',
  'workflow.connect.heroTitle': 'Gebruik %{workflow} vanuit je AI assistent',
  // eslint-disable-next-line max-len
  'workflow.connect.heroBody': 'Voeg onderstaande URL als MCP-server toe in Claude. Log één keer in met je SecureAccess account; daarna verschijnt de workflow als tool in elke conversatie.',
  'workflow.connect.step.add': 'Toevoegen als MCP server',
  'workflow.connect.step.addHint': 'Bewerk je Claude Desktop config en herstart Claude Desktop.',
  'workflow.connect.inactiveAlert': 'Authenticatie werkt pas als deze workflow is geactiveerd voor je organisatie.',
  'workflow.connect.step.login': 'Inloggen bij SecureAccess',
  // eslint-disable-next-line max-len
  'workflow.connect.step.loginHint': 'De eerste keer opent Claude een browservenster voor de SecureAccess OAuth-flow. Goedkeuren en de connectie staat aan jouw account gekoppeld.',
  'workflow.connect.step.prompt': 'Probeer het uit',
  // eslint-disable-next-line max-len
  'workflow.connect.step.promptHint': 'In een nieuwe chat verschijnt de workflow als tool. Vraag Claude om hem te gebruiken met een natuurlijke instructie.',
  'workflow.connect.desktop.step1Title': 'Toevoegen aan claude_desktop_config.json',
  // eslint-disable-next-line max-len
  'workflow.connect.desktop.step1Hint': 'Open Claude Desktop instellingen → Developer → Edit config, plak het fragment hieronder, sla op en herstart Claude Desktop.',
  'workflow.connect.code.step1Title': 'Run claude mcp add',
  'workflow.connect.code.step1Hint': 'Voer in een terminal het commando hieronder uit. Claude Code registreert de workflow voor het huidige project.',
  'workflow.connect.web.step1Title': 'Voeg een custom connector toe op claude.ai',
  // eslint-disable-next-line max-len
  'workflow.connect.web.step1Hint': 'Open de Connectors pagina in je Claude.ai instellingen, kies Add custom connector en plak de URL.',
  'workflow.connect.noAccess.title': 'Nog geen toegang',
  'workflow.connect.noAccess.body': 'Vraag eerst toegang aan tot deze workflow.',
  'workflow.loadError': 'Kan workflows niet laden',
  'workflow.actionError': 'Actie mislukt. Probeer het opnieuw.',
  'workflow.ai.button': 'Genereer met AI',
  'workflow.ai.title': 'AI-workflowgenerator',
  'workflow.ai.intro':
    'Beschrijf het proces dat de workflow moet uitvoeren. Geef details over hoe de workflow gestart moet worden, de stappen in het proces en je verwachte resultaat. Onze AI analyseert je omschrijving en als die voldoende informatie heeft, kun je de workflow ter goedkeuring aanbieden.',
  'workflow.ai.guide.title': 'Hoe een workflow is opgebouwd',
  'workflow.ai.guide.subtitle': 'Klik voor een korte uitleg van de bouwstenen.',
  'workflow.ai.guide.triggerTitle': 'Trigger',
  'workflow.ai.guide.triggerBody':
    'Elke workflow begint met een trigger — een handmatige actie, een schema (bijv. elke werkdag om 9:00), of een binnenkomende webhook vanuit een ander systeem.',
  'workflow.ai.guide.toolTitle': 'Verbinden met een systeem',
  'workflow.ai.guide.toolBody':
    'Tool-stappen halen data op uit of veranderen data in een gekoppeld MCP-systeem (Topdesk, Slack, het zaaksysteem, ...). Noem het systeem en wat het moet doen.',
  'workflow.ai.guide.aiTitle': 'Laat AI denken',
  'workflow.ai.guide.aiBody':
    'AI-stappen kunnen samenvatten, vertalen, classificeren of specifieke velden uit eerdere output halen. Wees concreet over de input en het gewenste resultaat.',
  'workflow.ai.guide.logicTitle': 'Logica & loops',
  'workflow.ai.guide.logicBody':
    'Gebruik condities ("alleen als status = open") en loops ("voor elk ticket, ...") om te bepalen hoe de workflow door je data heen loopt.',
  'workflow.ai.guide.outputTitle': 'Eindbestemming',
  'workflow.ai.guide.outputBody':
    'Vertel de beheerder waar het resultaat heen moet: een Slack-kanaal, een mail, een notificatie, een nieuwe zaak of een visualisatie in het dashboard.',
  'workflow.ai.guide.exampleTitle': 'Voorbeeld',
  'workflow.ai.guide.exampleBody':
    '"Haal openstaande items op uit systeem A, laat AI ze samenvatten en plaats het resultaat in systeem B."',
  'workflow.ai.descriptionLabel': 'Beschrijf de workflow',
  'workflow.ai.descriptionPlaceholder':
    'Elke werkdag om 9:00 de openstaande Topdesk-tickets ophalen, samenvatten met een LLM en de samenvatting in #service-desk op Slack plaatsen.',
  'workflow.ai.submit': 'Doorgaan',
  'workflow.ai.analyzing': 'Beschrijving wordt geanalyseerd…',
  'workflow.ai.needsMoreInfo': 'Ik heb nog wat extra informatie nodig',
  'workflow.ai.answerLabel': 'Voeg de ontbrekende details toe',
  'workflow.ai.answerPlaceholder': 'Geef de ontbrekende informatie…',
  'workflow.ai.summaryTitle': 'Dit wordt gebouwd',
  'workflow.ai.summaryHintRequest':
    'Een beheerder beoordeelt deze beschrijving en bouwt de workflow zodra hij is goedgekeurd.',
  'workflow.ai.requestButton': 'Aanvragen',
  'workflow.ai.edit': 'Beschrijving aanpassen',
  'workflow.ai.requesting': 'Aanvraag wordt verstuurd…',
  'workflow.ai.requestedTitle': 'Aanvraag verstuurd',
  'workflow.ai.requestedMessage':
    'Een beheerder is op de hoogte. Je hoort het zodra de workflow is gebouwd.',
  'workflow.ai.close': 'Sluiten',
  'workflow.ai.errorTitle': 'Er is iets misgegaan',
  'workflow.ai.errorBody': 'De assistent kon deze aanvraag niet verwerken.',
  'workflow.ai.retry': 'Opnieuw proberen',
  'myRequests.aiRequests.sectionTitle': 'AI-workflow aanvragen',
  'myRequests.aiRequests.col.prompt': 'Omschrijving',
  'workflow.nodeDetail.title': 'Node configuratie',
  'workflow.nodeDetail.triggerType': 'Trigger type',
  'workflow.nodeDetail.cronExpression': 'Schema',
  'workflow.nodeDetail.webhookPath': 'Webhook pad',
  'workflow.nodeDetail.server': 'MCP Server',
  'workflow.nodeDetail.tool': 'Tool',
  'workflow.nodeDetail.parameters': 'Parameters',
  'workflow.nodeDetail.expression': 'Expressie',
  'workflow.nodeDetail.arrayExpression': 'Array expressie',
  'workflow.nodeDetail.itemVariable': 'Item variabele',
  'workflow.nodeDetail.strategy': 'Strategie',
  'workflow.nodeDetail.mappings': 'Veld mappings',
  'workflow.nodeDetail.triggerButton': 'Workflow starten',
  'workflow.nodeDetail.triggerSuccess': 'Workflow succesvol gestart',
  'workflow.nodeDetail.triggerError': 'Kon workflow niet starten',
  'workflow.nodeDetail.type': 'Type',

  'workflow.backButton': 'Terug naar workflows',
  'workflow.remove': 'Verwijder workflow',
  'workflow.removing': 'Verwijderen...',
  'workflow.removeConfirm': 'Weet je zeker dat je deze workflow wilt verwijderen? Alle toegang wordt ingetrokken en alle uitvoering-registraties (executies en verbruikslogs) worden permanent verwijderd.',
  'workflow.trigger': 'Uitvoeren',
  'workflow.triggerSuccess': 'Workflow gestart',
  'workflow.variables.missingTitle': 'Variabelen ontbreken',
  'workflow.variables.missingBody': 'Deze workflow verwijst naar variabelen waarvoor je organisatie nog geen waarde heeft. Laat een beheerder ze invullen via de koppeling-configuratie voor de volgende uitvoering.',
  'workflow.tabs.about': 'Over',
  'workflow.tabs.tools': 'Tools',
  'workflow.badge.mcp': 'MCP',
  'workflow.badge.ai': 'AI',
  'workflow.badge.mcpTooltip': 'Beschikbaar als MCP-tool voor AI-clients',
  'workflow.badge.aiTooltip': 'Bevat een AI-stap',
  'workflow.tabs.diagram': 'Diagram',
  'workflow.tabs.executions': 'Uitvoeringen',
  'workflow.about.empty': 'Geen beschrijving beschikbaar',
  'workflow.executions.empty': 'Nog geen uitvoeringen',
  'workflow.executions.status': 'Status',
  'workflow.executions.trigger': 'Trigger',
  'workflow.executions.startedBy': 'Gestart door',
  'workflow.executions.started': 'Gestart',
  'workflow.executions.duration': 'Duur',
  'workflow.executionStatus.pending': 'Wachtend',
  'workflow.executionStatus.running': 'Actief',
  'workflow.executionStatus.completed': 'Voltooid',
  'workflow.executionStatus.failed': 'Mislukt',
  'workflow.triggerType.manual': 'Handmatig',
  'workflow.triggerType.cron': 'Gepland',
  'workflow.triggerType.webhook': 'Webhook',
  'workflow.stats.nodes': '{count} nodes',
  'workflow.stats.trigger': 'Trigger: {type}',
  'workflow.notFound.title': 'Workflow niet gevonden',

  'workflow.tabs.users': 'Gebruikers',

  'workflow.tabs.webhook': 'Webhook',
  'workflow.webhook.title': 'Webhook integratie',
  'workflow.webhook.description': 'Trigger deze workflow vanuit een extern systeem door een POST request te sturen naar onderstaande URL.',
  'workflow.webhook.url': 'Webhook URL',
  'workflow.webhook.auth': 'Authenticatie',
  'workflow.webhook.authDescription': 'Voeg een geldig Bearer token toe in de Authorization header.',
  'workflow.webhook.parameters': 'Parameters',
  'workflow.webhook.parametersDescription': 'Stuur parameters als JSON in de request body onder de "trigger_input" key.',
  'workflow.webhook.name': 'Naam',
  'workflow.webhook.type': 'Type',
  'workflow.webhook.required': 'Verplicht',
  'workflow.webhook.optional': 'Optioneel',
  'workflow.webhook.descriptionCol': 'Beschrijving',
  'workflow.webhook.example': 'Voorbeeld request',
  'workflow.webhook.noLink': 'Webhook is beschikbaar nadat de workflow aan je organisatie is gekoppeld.',

  'workflow.visualizations.title': 'Visualisaties',

  'visualization.noData': 'Geen data beschikbaar. Voer de workflow eerst uit.',
  'visualization.accessDenied.title': 'Geen toegang',
  'visualization.accessDenied.body': 'Je hebt geen toegang tot deze visualisatie. Neem contact op met je beheerder.',
  'visualization.notFound.title': 'Niet gevonden',
  'visualization.notFound.body': 'Deze visualisatie is niet gevonden.',
};
